import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(1.5),
      borderRadius: theme.shape.borderRadius,

      '&:hover': {
        background: COLORS.gray.gray90,
      },
    },
    listItemIcon: {
      minWidth: 24,

      '& svg': {
        color: COLORS.gray.gray30,
        fontSize: theme.typography.pxToRem(16),
      },
    },
  }),
  { name: 'InternalListItem' }
);
